export default __webpack_public_path__ + "static/media/vmatic.eb7ed1c1.png";